function TimelineForm({
  newTimeline,
  setNewTimeline,
  guardarTimeline,
  editingTimelineId,
  cancelarEdicionTimeline,
  projectActors
}) {
  const actorSeleccionado = projectActors.find(a => a.nombre === newTimeline.actor);

  return (
    <div style={styles.formBox}>
      <h2 style={styles.title}>
        {editingTimelineId ? 'Editar evento' : 'Nuevo evento territorial'}
      </h2>

      {/* ACTOR — primero */}
      <div style={styles.actorBox}>
        <div style={styles.actorLabel}>Actor territorial vinculado</div>
        <select
          style={styles.actorSelect}
          value={newTimeline.actor || ''}
          onChange={(e) =>
            setNewTimeline({ ...newTimeline, actor: e.target.value })
          }
        >
          <option value="">Selecciona el actor al que pertenece este evento</option>
          {projectActors.map((actor) => (
            <option key={actor.id} value={actor.nombre}>
              {actor.nombre}
            </option>
          ))}
        </select>

        {actorSeleccionado && (
          <div style={styles.actorPreview}>
            <span style={styles.actorNombre}>{actorSeleccionado.nombre}</span>
            <span style={styles.actorMeta}>
              {actorSeleccionado.sector} · {actorSeleccionado.comuna} ·
              Riesgo {actorSeleccionado.riesgo}
            </span>
          </div>
        )}
      </div>

      {/* CAMPOS DEL EVENTO */}
      <div style={styles.grid}>
        <input
          style={{ ...styles.input, gridColumn: 'span 2' }}
          placeholder="Título del evento — qué ocurrió"
          value={newTimeline.titulo || ''}
          onChange={(e) =>
            setNewTimeline({ ...newTimeline, titulo: e.target.value })
          }
        />

        <select
          style={styles.input}
          value={newTimeline.tipo || ''}
          onChange={(e) =>
            setNewTimeline({ ...newTimeline, tipo: e.target.value })
          }
        >
          <option value="">Tipo de evento</option>
          <option value="Reunión">Reunión</option>
          <option value="Llamada telefónica">Llamada telefónica</option>
          <option value="Visita territorial">Visita territorial</option>
          <option value="Mesa de trabajo">Mesa de trabajo</option>
          <option value="Declaración pública">Declaración pública</option>
          <option value="Conflicto">Conflicto</option>
          <option value="Acuerdo">Acuerdo</option>
          <option value="Manifestación">Manifestación</option>
          <option value="Alerta comunitaria">Alerta comunitaria</option>
          <option value="Nota de prensa">Nota de prensa</option>
        </select>

        <input
          type="date"
          style={styles.input}
          value={newTimeline.fecha || ''}
          onChange={(e) =>
            setNewTimeline({ ...newTimeline, fecha: e.target.value })
          }
        />
      </div>

      <textarea
        style={styles.textarea}
        placeholder="Descripción — qué pasó, quiénes participaron, qué se acordó..."
        value={newTimeline.descripcion || ''}
        onChange={(e) =>
          setNewTimeline({ ...newTimeline, descripcion: e.target.value })
        }
      />

      <div style={styles.buttons}>
        <button style={styles.button} onClick={guardarTimeline}>
          {editingTimelineId ? 'Guardar cambios' : 'Guardar evento'}
        </button>
        {editingTimelineId && (
          <button style={styles.cancelButton} onClick={cancelarEdicionTimeline}>
            Cancelar
          </button>
        )}
      </div>
    </div>
  );
}

const styles = {
  formBox: {
    background: 'white',
    padding: '30px',
    borderRadius: '14px',
    marginBottom: '30px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.08)'
  },
  title: {
    marginTop: 0,
    marginBottom: '20px',
    color: '#071a2f'
  },
  actorBox: {
    background: '#f0f9ff',
    border: '1px solid #bae6fd',
    borderRadius: '12px',
    padding: '18px',
    marginBottom: '20px'
  },
  actorLabel: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#075985',
    marginBottom: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  actorSelect: {
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #bae6fd',
    fontSize: '15px',
    background: 'white'
  },
  actorPreview: {
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  actorNombre: {
    fontWeight: 'bold',
    color: '#075985',
    fontSize: '15px'
  },
  actorMeta: {
    color: '#667085',
    fontSize: '13px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '14px',
    marginBottom: '16px'
  },
  input: {
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #d0d5dd',
    fontSize: '14px',
    boxSizing: 'border-box'
  },
  textarea: {
    width: '100%',
    minHeight: '120px',
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #d0d5dd',
    marginBottom: '20px',
    boxSizing: 'border-box',
    fontSize: '14px',
    lineHeight: '1.5'
  },
  buttons: {
    display: 'flex',
    gap: '10px'
  },
  button: {
    background: '#0891b2',
    color: 'white',
    border: 'none',
    padding: '14px 22px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  cancelButton: {
    background: '#d92d20',
    color: 'white',
    border: 'none',
    padding: '14px 22px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};

export default TimelineForm;